/**
 * 高亮组件
 *
 * @usgae
 * <Highlight keyword="xxx" text="xxx" caseSensitive={false} />
 * 默认忽略大小写
 */

import React from 'react';
import classnames from 'classnames';
import styles from './index.less';

const Highlight = (props) => {
  const { keyword = '', text, className = '', caseSensitive = false } = props;
  let html = null;
  try {
    // 转义特殊字符，避免正则匹配失败
    const sepcialCharacters = '[\\^$.|?*+()'.split('');
    const newKeyword = keyword
      .split('')
      .map((v) => {
        if (sepcialCharacters.indexOf(v) !== -1) {
          return `\\${v}`;
        }

        return v;
      })
      .join('');
    const pattern = new RegExp(`(${newKeyword})`, `g${caseSensitive ? '' : 'i'}`);
    html = text.replace(pattern, `<span class="${classnames(styles.highlight, className)}">$1</span>`);
  } catch (e) {
    html = text;
  }

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    ></span>
  );
};

export default Highlight;
